import React, { useState } from 'react'
import { Box, Grid, Stack, Tab, Tabs, Typography } from '@mui/material'
import { BillType } from '../../all-types'
import { TakeawayCard } from './components'
import { deliveryOptions } from '../../constants'

type TabValue = 'PENDING' | 'READY'

interface TakeawayOrdersDisplayProps {
  takeawayBills: BillType[]
  setTakeawayBills: React.Dispatch<React.SetStateAction<BillType[]>> // To allow updates
  refersh?: () => void;
}

const TakeawayOrdersDisplay: React.FC<TakeawayOrdersDisplayProps> = ({
  takeawayBills,
  setTakeawayBills,
  refersh
}) => {

  const [selectedTab, setSelectedTab] = useState<TabValue>('PENDING')

  const handleTabChange = (_: React.SyntheticEvent, newValue: TabValue) => {
    setSelectedTab(newValue)
  }

  return (
    <Box sx={{ p: 2, bgcolor: 'background.paper' }}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 2 }}
      >
        <Tab
          label="Pending"
          value="PENDING"
          sx={{ textTransform: 'capitalize', fontWeight: 'bold' }}
        />
        <Tab
          label="Ready"
          value="READY"
          sx={{ textTransform: 'capitalize', fontWeight: 'bold' }}
        />
        <Tab
          label="History"
          value="DONE"
          sx={{ textTransform: 'capitalize', fontWeight: 'bold' }}
        />
      </Tabs>

      <Grid container spacing={3}>
        {takeawayBills?.filter(t => t.takeAwayStatus === selectedTab)?.length === 0 ? (
          <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
            <img src={deliveryOptions["Take-Away/Parcel"]?.logoUrl} style={{ width: "250px", height: "250px" }}></img>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ mt: 4, textAlign: 'center', width: '100%', fontWeight: "bold" }}
            >
              No ongoing takeaway orders.
            </Typography>
          </Stack>
        ) : (
          takeawayBills?.filter(t => t.takeAwayStatus === selectedTab)?.map((order) => (
            <TakeawayCard key={order?._id || order.billNo} order={order} refersh={refersh} />
          ))
        )}
      </Grid>
    </Box>
  )
}

export { TakeawayOrdersDisplay }
